var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIconMpr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.689 24.7699L25.7033 19.4525C25.7055 18.6681 26.0536 17.9255 26.6536 17.4287L27.401 16.8086",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.50589H8.1992L6.61725 0.828125L2.51879 0.847907L1 7.50589Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4895 7.5896V23.2915L6.02558 24.1946C6.28949 24.3498 6.17971 24.7591 5.8737 24.7569L3.23688 24.7401C2.93838 24.7386 2.82786 24.343 3.08049 24.1832L4.48875 23.2915",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66479 7.5896V12.6255",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1012 12.7671H25.2146C26.4221 12.7671 27.4011 13.7577 27.4011 14.9796V16.8078L28.1439 17.3838C28.7853 17.8806 29.1612 18.6513 29.1612 19.4692V24.7691L8.03431 24.6763L7.98619 19.4684C7.97942 18.7099 8.29671 17.9856 8.85686 17.4812L9.71174 16.712V15.0891C9.71174 13.8672 10.6907 12.8766 11.8982 12.8766H13.5147",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4916 24.6914L11.5021 19.4494C11.5036 18.6634 11.1577 17.9186 10.5585 17.418L9.71265 16.7119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5046 20.7017H25.6895",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconMpr);
export default __webpack_public_path__ + "static/media/feature-icon-mpr.96923140.svg";
export { ForwardRef as ReactComponent };